<template>
  <img
    :src="
      $store.state.darkMode
        ? require('../../assets/header/white-logo.svg')
        : require('../../assets/header/black-logo.svg')
    "
    alt="القيصر محمد طارق لوجو"
    class="w-100 h-100"
  />
</template>
<script>
export default {
  name: "SiteLogo",
};
</script>
<style scoped></style>
